export default "__VITE_ASSET___KJECOu2__"